import Vue from 'vue'
import VueRouter from 'vue-router'

import Welcome from '@/components/Welcome'
import HomeNode from '@/components/HomeNode'
import Release from '@/components/Release'
import Help from '@/components/Help'
import NodesContainer from '@/components/containers/NodesContainer'
import Error404 from '@/components/Error404'
import Ecosystem from '@/components/Ecosystem'
import NodeContainer from '@/components/containers/NodeContainer'
import NodeDashboard from '@/components/NodeDashboard'
import NodeAdministration from '@/components/NodeAdministration'
import Authentication from '@/components/Authentication'
import ProjectsContainer from '@/components/containers/ProjectsContainer'
import Projects from '@/components/Projects'
import ProjectContainer from '@/components/containers/ProjectContainer'
import ProjectDashboard from '@/components/ProjectDashboard'
import ApiKeysContainer from '@/components/containers/ApiKeysContainer'
import ApiKeys from '@/components/ApiKeys'
import ApiKey from '@/components/ApiKey'
import CollectionsContainer from '@/components/containers/CollectionsContainer'
import Collections from '@/components/Collections'
import CollectionContainer from '@/components/containers/CollectionContainer'
import CollectionDashboard from '@/components/CollectionDashboard'
import DataObjectsContainer from '@/components/containers/DataObjectsContainer'
import DataObjects from '@/components/DataObjects'
import DataObject from '@/components/DataObject'
import AccountsContainer from '@/components/containers/AccountsContainer'
import Accounts from '@/components/Accounts'
import Account from '@/components/Account'
import SchemasContainer from '@/components/containers/SchemasContainer'
import Schemas from '@/components/Schemas'
import Schema from '@/components/Schema'

//import Store from '@/store'

Vue.use(VueRouter)

var router = new VueRouter({
	routes: [
		{ path : '/', name : 'homenode', component : HomeNode, meta : { public : true } },
		{ path : '/welcome', name : 'welcome', component : Welcome, meta : { public : true } },
		{ path : '/release', name : 'release', component : Release, meta : { public : true } },
		{ path : '/help', name : 'help', component : Help, meta : { public : true } },
		{ path : '/homenode', redirect : ( to ) => { console.warn( "TODO: Figure out current node ID and return that..." ); return '/nodes/<my-node-id>' } },
		{ path : '/authentication', name : 'authentication', component : Authentication, props : true, meta : { public : true } },
		{ path : '/nodes', component : NodesContainer, meta : { public : true }, children : [		
			{ path : '', name : 'nodes', component : Ecosystem, meta : { public : true } },
			{ path : ':nodeId', component : NodeContainer, props : true, meta : { public : true }, children : [
				{ path : '', name : 'node', component : NodeDashboard, props : true, meta : { public : true } },
				{ path : 'admin', name : 'node.admin', component : NodeAdministration, props : true },
				{ path : 'accounts', component : AccountsContainer, props : true, children : [
					{ path : '', name : 'accounts', component : Accounts, props : true },
					{ path : ':accountId', name : 'account', component : Account, props : true }
				]},
				{ path : 'projects', component : ProjectsContainer, props : true, children : [
					{ path : '', name : 'projects', component : Projects, props : true },
					{ path : ':projectId', component : ProjectContainer, props : true, children : [
						{ path : '', name : 'project', component : ProjectDashboard, props : true },
						{ path : 'apikeys', component : ApiKeysContainer, props : true, children : [
							{ path : '', name : 'apikeys', component : ApiKeys, props : true },
							{ path : ':theKey', name : 'apikey', component : ApiKey, props : true }
						]},
						{ path : 'schemas', component : SchemasContainer, props : true, children : [
							{ path : '', name : 'schemas', component : Schemas, props : true },
							{ path : ':schemaName', name : 'schema', component : Schema, props : true }
						]},
						{ path : 'collections', component : CollectionsContainer, props : true, children : [
							{ path : '', name : 'collections', component : Collections, props : true },
							{ path : ':collectionName', component : CollectionContainer, props : true, children : [
								{ path : '', name : 'collection', component : CollectionDashboard, props : true },
								{ path : 'objects', component : DataObjectsContainer, props : true, children : [
									{ path : '', name : 'objects', component : DataObjects, props : true },
									{ path : ':objectId', name : 'object', component : DataObject, props : true },
								]},
							]},
						]},
					]},
				]},
			]},
		]},
		{ path : '*', name : 'error-404', component : Error404, props : true, meta : { public : true } },
	]
});

export default router;


// router.beforeEach((to, from, next) =>
// {
// 	if( true !== to.meta.public && null == Store.getters['authentication/sessionKey'] )
// 	{
// 		console.log( "Navigating to auth..." );
// 		next( { name : 'authentication', params : { dog : "DOG", nodeId : to.params.nodeId } } );
// 		//next( );
// 	}
// 	else {
// 		next( );
// 	}
// })

/*
/										Redirects to /welcome or /nodes/<this-node>, if dismissed with "remember" cookie.
/help									Docs, guide, tutorials, etc.
/welcome								Introductory welcome page (can be dismissed with "remember", defaulting to /nodes/<this-node>)
											also provides link to /nodes/<this-node>
/homenode								REDIRECTS to /nodes/<this-node>
/nodes									Ecosystem browser
	/:nodeId							REDIRECTS to /dashboard, or /auth if not logged in.
		/dashboard						My dashboard for current node (includes node search component, which can be "popped out" to /search.
		/manage							Manage this node if NODE-ADMIN (initially, only allowed to manage THIS node)
		/accounts
			/:accountId
		/auth							Login, Logout, Auth-key for current node
		/projects						Projects I have access to, on current node.
			/:projectId					Project info and settings
				/apikeys				API Keys in this project, if I'm an admin
				/collections			Collections in this project, that I have access to
					/:collectionName	Collection info and settings
						/objects		Object contents of this collection
							/:objectId	Object with this ID
				/search					FUTURE: DATA true federated search for objects from all collections (API keys can have access)
				/schemas				FUTURE ($sys ones are included pre-collapsed in every project)
				/mixins					FUTURE ($sys ones are included pre-collapsed in every project)
				/validators				FUTURE ($sys ones are included pre-collapsed in every project)
				/endpoints				FUTURE (BaaS feature, with custom code?)
		/accounts						Accounts I have access to
			/:accountId					Account with this ID
		/sessions						Sessions I have access to
		/search							Search limited to this node for various things. Fixed versions of this will be available as
											supplements within each section (projects, collections, accounts, etc.)
*/


// WEBPACK FOOTER //
// ./src/router/index.js